import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

import { PatientEmergencyContactsComponent } from './patient-emergency-contacts/patient-emergency-contacts.component';
import { PatientFacilitiesComponent } from './patient-facilities/patient-facilities.component';
import { PatientModalitiesComponent } from './patient-modalities/patient-modalities.component';
import { PatientProvidersComponent } from './patient-providers/patient-providers.component';

@NgModule({
  declarations: [
    PatientEmergencyContactsComponent,
    PatientFacilitiesComponent,
    PatientModalitiesComponent,
    PatientProvidersComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatDividerModule
  ],
  exports: [
    PatientEmergencyContactsComponent,
    PatientFacilitiesComponent,
    PatientModalitiesComponent,
    PatientProvidersComponent
  ]
})
export class PatientDetailsSharedModule { }
